/*
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version:
 * @Author: Duanshuai
 * @Date: 2021-03-18 16:43:02
 * @LastEditors: ------
 * @LastEditTime: 2021-08-26 09:21:30
 */

// 导入请求插件

import axios from "axios";

// 执行ajax-get请求的函数
function getRequest(url, params) {
  return new Promise(resolve => {
    axios.get(url, { params }).then(res => {
      resolve(res.data);
    });
  });
}

// 执行ajax-post请求的函数
function postRequest(url, params) {
  return new Promise(resolve => {
    axios.post(url, { params }).then(res => {
      resolve(res.data);
    });
  });
}

// 获取新闻列表
function newslist(params) {
  return getRequest(
    "https://api.aijiehu.cn/gateway-ext/news/news/platList",
    params
  );
}
//新闻详情页
function newsdetail(params) {
  return getRequest(
    "https://api.aijiehu.cn/gateway-ext/news/news/detail",
    params
  );
  // return getRequest(
  //   "https://api.aijiehu.cn/gateway-ext/news/news/detail",
  //   params
  // );
}

// 把请求数据的函数导出
export { newslist, newsdetail };



//////////////////
// WEBPACK FOOTER
// ./tools/ajax.js
// module id = 8a2d
// module chunks = 8